// extracted by mini-css-extract-plugin
export default {"listingsEventCardUrgencySignals":"ListingsEventCard-module__listingsEventCardUrgencySignals___3vlBV","promotedLabel":"ListingsEventCard-module__promotedLabel___1Qwa3"};